// React
import React from 'react';

// Redux
import { useSelector } from 'react-redux';

// Components
import CollapsableSideBar from '../Shared/Navigation/CollapsableSideBar';

// Assets
import {CDN_LINK} from '../../../src/assets/img';

// CSS
import './index.scss';

const Sidebar = (props) => {
  const { content, tenantConfig  } = useSelector((state) => {
    return {
      content: state?.ContentReducer?.content,
      tenantConfig: state?.TenantConfigReducer?.tenantConfig
    };
  });
  const headerContent = content?.components?.header;
  return (
    <React.Fragment>
      {tenantConfig?.header?.ribbon &&
        <div className='bosch_strip'>
          <img src={`${CDN_LINK}/${headerContent?.images?.ribbon?.image}`} alt={`${headerContent?.images?.ribbon?.alt}`} />
        </div>
      }
      <CollapsableSideBar {...props} />
    </React.Fragment>
  );
};

export default Sidebar;
